// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

/* overridden by src/lib/themes/guiHelpers.js */

/*
    Contains constants for the z-index values of elements that are part of the global stack context.
    In other words, z-index values that are "inside" a component are not added here.
    This prevents conflicts between identical z-index values in different components.
*/

/* Toolbox z-index: 40; set in scratch-blocks */

/* tooltips should go over add buttons if they overlap */

/* monitors go over add buttons */

/* "ask" block text input goes above monitors */

/* menu-bar should go over monitors, alerts and tutorials */

/* behind menu-bar */

/* Block drag z-index: 1000; default 50 is overriden in blocks.css */

/* so it is draggable into other panes */

/* behind modals */

/* behind modals */

/* in most interfaces, the context menu is always on top */

.stage-wrapper_stage-wrapper_I7Awm {
    position: relative;
}

.stage-wrapper_stage-wrapper_I7Awm * {
    box-sizing: border-box;
}

.stage-wrapper_stage-canvas-wrapper_hvRk6 {
    /* Hides negative space between edge of rounded corners + container, when selected */
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
}

.stage-wrapper_offset-controls_mAtgc .stage-wrapper_stage-canvas-wrapper_hvRk6 {
    padding-top: 44px;
}

.stage-wrapper_stage-wrapper_I7Awm.stage-wrapper_full-screen_vAajd {
    position: fixed;
    top: 2.75rem;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 500;
    background-color: var(--fullscreen-background);
    /* spacing between stage and control bar (on the top), or between
    stage and window edges (on left/right/bottom) */
    padding: 0.1875rem;

    /* this centers the stage */
    display: flex;
    flex-direction: column;
    align-items: center;
}

.stage-wrapper_stage-wrapper_I7Awm.stage-wrapper_embedded_HbEPT {
    background-color: transparent;
}
`, "",{"version":3,"sources":["webpack://./src/components/stage-wrapper/stage-wrapper.css"],"names":[],"mappings":"AAAA;sDACsD;;AAEtD,+CAA+C;;AAE/C,+CAA+C;;AAE/C;;;;CAIC;;AAED,+CAA+C;;AAE/C,wDAAwD;;AAExD,iCAAiC;;AAEjC,+CAA+C;;AAE/C,2DAA2D;;AAE3D,oBAAoB;;AAEpB,oEAAoE;;AAEpE,wCAAwC;;AAExC,kBAAkB;;AAElB,kBAAkB;;AAElB,0DAA0D;;AAE1D;IACI,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,oFAAoF;IACpF,yBAAyB;OACtB,sBAAsB;QACrB,qBAAqB;YACjB,iBAAiB;AAC7B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,OAAO;IACP,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,8CAA8C;IAC9C;mDAC+C;IAC/C,kBAAkB;;IAElB,2BAA2B;IAC3B,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;AACjC","sourcesContent":["/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n/* overridden by src/lib/themes/guiHelpers.js */\n\n/*\n    Contains constants for the z-index values of elements that are part of the global stack context.\n    In other words, z-index values that are \"inside\" a component are not added here.\n    This prevents conflicts between identical z-index values in different components.\n*/\n\n/* Toolbox z-index: 40; set in scratch-blocks */\n\n/* tooltips should go over add buttons if they overlap */\n\n/* monitors go over add buttons */\n\n/* \"ask\" block text input goes above monitors */\n\n/* menu-bar should go over monitors, alerts and tutorials */\n\n/* behind menu-bar */\n\n/* Block drag z-index: 1000; default 50 is overriden in blocks.css */\n\n/* so it is draggable into other panes */\n\n/* behind modals */\n\n/* behind modals */\n\n/* in most interfaces, the context menu is always on top */\n\n.stage-wrapper {\n    position: relative;\n}\n\n.stage-wrapper * {\n    box-sizing: border-box;\n}\n\n.stage-canvas-wrapper {\n    /* Hides negative space between edge of rounded corners + container, when selected */\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n}\n\n.offset-controls .stage-canvas-wrapper {\n    padding-top: 44px;\n}\n\n.stage-wrapper.full-screen {\n    position: fixed;\n    top: 2.75rem;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 500;\n    background-color: var(--fullscreen-background);\n    /* spacing between stage and control bar (on the top), or between\n    stage and window edges (on left/right/bottom) */\n    padding: 0.1875rem;\n\n    /* this centers the stage */\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.stage-wrapper.embedded {\n    background-color: transparent;\n}\n"],"sourceRoot":""}]);
// Exports
var _1 = `stage-wrapper_stage-wrapper_I7Awm`;
export { _1 as "stage-wrapper" };
export var stageWrapper = `stage-wrapper_stage-wrapper_I7Awm`;
var _2 = `stage-wrapper_stage-canvas-wrapper_hvRk6`;
export { _2 as "stage-canvas-wrapper" };
export var stageCanvasWrapper = `stage-wrapper_stage-canvas-wrapper_hvRk6`;
var _3 = `stage-wrapper_offset-controls_mAtgc`;
export { _3 as "offset-controls" };
export var offsetControls = `stage-wrapper_offset-controls_mAtgc`;
var _4 = `stage-wrapper_full-screen_vAajd`;
export { _4 as "full-screen" };
export var fullScreen = `stage-wrapper_full-screen_vAajd`;
export var embedded = `stage-wrapper_embedded_HbEPT`;
export default ___CSS_LOADER_EXPORT___;
